import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { SelectOption } from "shared/types/Select"

import { useProjectPhases } from "entities/projects/model/useProjectPhases"

export function useProjectPhaseFilterOptions() {
  const { t } = useTranslation()
  const { projectPhases, isLoading } = useProjectPhases()

  const projectPhaseFilterOptions = useMemo(() => {
    const result: SelectOption<string>[] = []
    if (projectPhases) {
      result.push(...projectPhases)
    }
    return result
  }, [projectPhases, t])

  return { options: projectPhaseFilterOptions, isLoading }
}
